// @module C3.ShoppingExtensions.NewArrivals
define('C3.ShoppingExtensions.YouMayAlsoNeed.Collection'
,	[
	   'Item.Collection'
       //'MasterOptionsHelper'	
    ]
, function (
	ItemCollection
   // MasterOptionsHelper
)
{
    'use strict';

	// @class C3.ShoppingExtensions.NewArrivals.View @extends Backbone.View
	return ItemCollection.extend({
    initialize: function(options) {
       //this.searchApiMasterOptions = MasterOptionsHelper.getSearchAPIMasterOption('correlatedItems');
       this.searchApiMasterOptions = options.configuration.searchApiMasterOptions.correlatedItems;
        this.itemsIds = _.isArray(options.itemsIds)
            ? _.sortBy(options.itemsIds, function(id) {
                  return id;
              })
            : [options.itemsIds];
    },

    // @method fetchItems @return {jQuery.Deferred}
    fetchItems: function() {
        return this.fetch({ data: { id: this.itemsIds.join(',') } });
    },

    // http://backbonejs.org/#Model-parse
    parse: function(response) {
        const original_items = _.compact(response.items) || [];
        const self = this;
        const items = {};

        _.each(_.pluck(original_items, 'correlateditems_detail'), function(correlated_items) {
            _.each(correlated_items, function(correlated_item) {
                if (
                    self &&
                    self.itemsIds &&
                    correlated_item &&
                    items &&
                    !_.contains(self.itemsIds, correlated_item.internalid) &&
                    !items[correlated_item.internalid]
                ) {
                    items[correlated_item.internalid] = correlated_item;
                }
            });
        });

        return _.toArray(items);
    }

	});
});
